// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Glgn","colBig":"styles_colBig__21x9N","colSmall":"styles_colSmall__2e0-O","shopifyNameWrapper":"styles_shopifyNameWrapper__2WV5a"};